import getBasePath from '../../../../common/functions/api-resource';

export const basePath = getBasePath('apuracao', 'reivindicacao');

const importacaoActions = {
  upload: { method: 'POST', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, importacaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/upload-reivindicacao.js